import { useEffect, useState } from 'react'
import Link from 'next/link'
import { Form } from 'react-bootstrap'
import phone from 'phone'
import { getItem } from '../lib/asyncStorage'
import { useFunctions } from '../hooks'
import Layout from '../components/Layout'
import { logPageView } from '../lib/analytics'
import logErr from '../lib/err'
import { REFERRAL_REGEX, CREW_REGEX } from '../globals'
import { useRouter } from 'next/router'

const phoneIcon = '/static/landslide/images/landslide-phone.png'

export default function desktop() {
  const [phoneNumber, setPhoneNumber] = useState('')
  const [msgSent, setMsgSent] = useState(false)
  const fns = useFunctions()
  const linkMe = fns && fns.httpsCallable('linkMe')
  const [pending, setPending] = useState(false)
  const [error, setError] = useState()
  const router = useRouter()

  const { query } = router
  const parsedPhone = phone(phoneNumber)
  const phoneNumberIsValid = parsedPhone?.length === 2 && parsedPhone[1] === 'USA'

  useEffect(() => {
    logPageView('desktop')
  }, [])

  const handleSubmit = async (e) => {
    e.preventDefault()
    e.stopPropagation()
    setError(null)
    setPending(true)

    try {
      const data = { phone: parsedPhone[0] }
      if (typeof window !== 'undefined') {
        const refer = query.r || (await getItem('refer'))
        const crew = query.c || (await getItem('crew'))
        if (crew && CREW_REGEX.test(crew)) {
          data.crew = crew
        } else if (refer && REFERRAL_REGEX.test(crew)) {
          data.refer = refer
        }
      }
      const response = await linkMe(data)
      console.log('linkMe response', response)
      if (response?.data?.result === 'sent') setMsgSent(true)
    } catch (err) {
      logErr(err, 'linkMe error')
      setError(err.message)
    }
    setPending(false)

    return
  }

  return (
    <Layout title="Welcome to Landslide" noStyle>
      <div id="desktop">
        <div id="container">
          <div id="text-content">
            <h1 id="logo">Landslide</h1>
            <h2>
              <span className="hashtag">#jointhelandslide</span> to encourage your friends to vote, get up-to-date voting info, and crush Trump and
              the GOP in November!
            </h2>
            <iframe
              id="video"
              width="448"
              height="252"
              src="https://www.youtube.com/embed/7NgLKECRtJ4"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
            <p>Enter your phone number and we'll text you a link.</p>
            {!msgSent ? (
              <>
                {error && <div className="error">There was an error: {error}</div>}
                <Form onSubmit={handleSubmit}>
                  <Form.Group className="custom-input">
                    <Form.Control
                      name="number"
                      id="number"
                      placeholder={'Your Phone Number'}
                      onChange={(e) => setPhoneNumber(e.target.value)}
                      type="text"
                      value={phoneNumber}
                      autoComplete="tel"
                    />
                    <button type="submit" onClick={handleSubmit} disabled={!phoneNumberIsValid} className="btn btn-primary fluid">
                      {!pending ? 'Submit' : 'Sending'}
                    </button>
                  </Form.Group>
                </Form>
              </>
            ) : (
              <h5>The link has been sent to your phone.</h5>
            )}
          </div>
          <div id="phone">
            <img src={phoneIcon} alt="" />
          </div>
        </div>
        <div id="bottom-bar">
          <p className="description">
            &#169; Landslide {new Date().getFullYear()} &nbsp;
            {process.env.DISPLAY_VERSION ? process.env.CURRENT_VERSION : ''}
          </p>
          <div className="right">
            <a target="_blank" rel="noreferrer" href="mailto:support@landslide2020.org">
              GET SUPPORT
            </a>
            <Link
              href={{
                pathname: '/privacy',
                query: { back: 'desktop' },
              }}
            >
              PRIVACY POLICY
            </Link>
            <Link
              href={{
                pathname: '/tou',
                query: { back: 'desktop' },
              }}
            >
              TERMS OF USE
            </Link>
          </div>
        </div>
      </div>
    </Layout>
  )
}
